import React, { useState, useEffect } from 'react';
import './admininbox.css';
import { db } from '../../config/firebase'; // Ensure the import path is correct
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { BiArrowToRight, BiEnvelopeOpen, BiEnvelope } from 'react-icons/bi';

const AdminInbox = () => {
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);

  useEffect(() => {
    const fetchMessages = async () => {
      const querySnapshot = await getDocs(collection(db, 'messages'));
      const messagesList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessages(messagesList);
    };

    fetchMessages();
  }, []);

  const handleSelectMessage = async (message) => {
    setSelectedMessage(message);
    if (!message.isRead) {
      await updateDoc(doc(db, 'messages', message.id), { isRead: true });
      const updatedMessages = messages.map((msg) =>
        msg.id === message.id ? { ...msg, isRead: true } : msg
      );
      setMessages(updatedMessages);
    }
  };

  const handleDeleteMessage = async (id) => {
    try {
      // Delete the document from Firestore
      await deleteDoc(doc(db, 'messages', id));

      // Update the messages state to remove the deleted message
      setMessages(prevMessages => prevMessages.filter(message => message.id !== id));

      // Reset the selectedMessage if it was deleted
      if (selectedMessage?.id === id) {
        setSelectedMessage(null);
      }

      alert('Message deleted successfully!');
    } catch (error) {
      console.error('Error deleting message:', error);
      alert('There was an error deleting the message. Please try again.');
    }
  };

  return (
    <div className='inbox_container'>
      <div className='inbox_intro'>
        <h1>Your Inbox</h1>
        <p>Manage your messages in one place. Stay organized, stay focused, and never miss a conversation.</p>
      </div>
      <div className='message_window'>
        <div className='message_popup'>
          <div className="message_popup_header">
            <h1>Messages</h1>
          </div>
          {messages.length > 0 ? (
            messages.map((message) => (
              <div
                className="message_popup_card"
                key={message.id}
                onClick={() => handleSelectMessage(message)}
              >
                {message.isRead ? (
                  <BiEnvelopeOpen className='open_icon' />
                ) : (
                  <BiEnvelope className='closed_icon' />
                )}
                <h2>Name: {message.volunteerName}</h2>
                <h2>Email: <span className='email_span'>{message.email}</span></h2>
                <BiArrowToRight className='arrow_icon' />
              </div>
            ))
          ) : (
            <div className="no_messages">
              <h2>No messages available</h2>
            </div>
          )}
        </div>
        <div className='message_show'>
          {selectedMessage ? (
            <div className='message_show_content'>
              <h2>Name: {selectedMessage.volunteerName}</h2>
              <h3>Email: <span className='email_span'>{selectedMessage.email}</span></h3>
              <p>{selectedMessage.message}</p>
              <div className='message_btn_container'>
                <button
                  className='message_btn'
                  onClick={() => handleDeleteMessage(selectedMessage.id)}
                >
                  Delete
                </button>
              </div>
            </div>
          ) : (
            <div className='message_show_content'>
              <h2>No message selected</h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminInbox;
